import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { HashRouter } from 'react-router-dom';

import { applyMiddleware, createStore } from 'redux';
import { Provider } from 'react-redux';
import rootReducer from './store/reducers/rootReducer';
import { thunk } from 'redux-thunk';

import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';

import { ThemeProvider as StyledThemeProvider } from 'styled-components'

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import { SnackbarProvider } from 'notistack';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_live_btebNtjR3AQlGUFYNar7CdS5');
//const stripePromise = loadStripe('pk_test_mpkPY0W4O03fIWaq3zb691oE');


// Neutral modern (chosen 2026-10-07 from the redesign mockup): cool greys,
// white cards with hairline borders, the brand blue as the only accent.
const NEUTRAL = {
  page: '#f4f5f7',
  surface: '#ffffff',
  ink: '#1d2330',
  muted: '#646b78',
  line: '#e3e6eb',
  field: '#f7f8fa',
  blue: '#009be1',
  blueDark: '#0075b8',
  blueSoft: '#e6f5fc'
}

const theme = createTheme({
  typography: {
    fontFamily: "'IBM Plex Sans', 'Open Sans', 'Segoe UI', Arial, sans-serif",
    useNextVariants: true,
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 }
  },
  shape: { borderRadius: 10 },
  shadows: Array(25).fill('none'),
  palette: {
    primary: {
      main: NEUTRAL.blue,
      dark: NEUTRAL.blueDark,
      light: NEUTRAL.blueSoft,
      default: NEUTRAL.ink
    },
    secondary: {
      main: "#1e7a46"
    },

    background: {
      paper: NEUTRAL.surface,
      default: NEUTRAL.page,
      label: NEUTRAL.blueSoft,
      note: '#fdf0d9',
      field: NEUTRAL.field
    },
    divider: NEUTRAL.line,
    error: {
      main: '#a83232'
    },
    warning: {
      main: '#9a5b00',
      default: '#9a5b00'
    },
    success: {
      main: '#1e7a46'
    },
    text: {
      primary: NEUTRAL.ink,
      secondary: NEUTRAL.muted,
      disabled: '#9aa0aa',
      highlight: NEUTRAL.blueDark
    },
    neutral: NEUTRAL

  },
  overrides: {

    MuiCssBaseline: {
      '@global': { body: { backgroundColor: NEUTRAL.page } }
    },
    MuiButton: {
      root: { borderRadius: 9, padding: '8px 16px' },
      contained: { boxShadow: 'none', '&:hover': { boxShadow: 'none' } },
      outlined: { borderColor: NEUTRAL.line, backgroundColor: NEUTRAL.surface }
    },
    MuiPaper: {
      rounded: { borderRadius: 10 }
    },
    MuiFormControl: {
      root: {
        display: 'flex'
      }
    },

    MuiFilledInput: {
      input: {
        padding: "12px 12px"

      },
      root: {
        backgroundColor: NEUTRAL.surface,
        border: `1px solid ${NEUTRAL.line}`,
        borderRadius: 9,
        '&:active': {
          backgroundColor: `${NEUTRAL.field} !important`,
        },
        '&:hover': {
          backgroundColor: `${NEUTRAL.field} !important`,
        }

      }
    },
    MuiTextField: {
      root: {
        padding: "6px 12px"

      },
    },
    MuiFormLabel: {
      root: {
        padding: "6px 12px"

      },
    },
    MuiTab: {
      root: { textTransform: 'none', fontWeight: 600 }
    },
    MuiAccordion: {
      root: {
        border: `1px solid ${NEUTRAL.line}`,
        borderRadius: '10px !important',
        '&:before': { display: 'none' },
        '&$expanded': { margin: 0 }
      }
    }
  }

});

//Can add saga later if needed
const middleWares = [thunk]

const store = createStore(rootReducer, applyMiddleware(...middleWares));

ReactDOM.render(
  <React.StrictMode>
    {/*basename="/projects/app-templates/rb-may/teetimes/" */}
    <HashRouter><MuiThemeProvider theme={theme}><StyledThemeProvider theme={theme}><Provider store={store}> <Elements stripe={stripePromise}><SnackbarProvider><App /></SnackbarProvider></Elements></Provider></StyledThemeProvider></MuiThemeProvider></HashRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
